import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, EventEmitter, OnInit, OnDestroy, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ApiService } from 'src/app/_services/api.service';
import { CookieService } from 'src/app/_services/cookie.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService } from '@syncfusion/ej2-angular-grids';

import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { AuthService } from 'src/app/_services/auth.service';


@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DetailRowService,SortService,ToolbarService],
  animations: [
    trigger('fadeIn', [
      state('in', style({ 'opacity': '1' })),
      state('out', style({ 'opacity': '0' })),
      transition('* => *', [
        animate(1000)
      ])
    ])
  ]
})
export class BannerComponent implements OnInit, OnDestroy {

  @ViewChild('ticketstable') ticketstable:any;
  @Output() messageEvent = new EventEmitter<boolean>();
  public toolbar!: string[];
  kpivalue='quattro';

  numeroDocumentiDaFirmare: number = 0;
  numeroDocumentiInAttesa: number = 0;
  intervalloFirme: any;
  
  kpilist:any[]=[];
  kpilistSelected:any[]=[];

  showSegnalazioni:boolean=false;
  segnalazioniAperte:any;


  showTickets:boolean=false;
  ticketsInCorso:any;

  showOrdini:boolean=false;
  ordiniDaApprovare:any=[];
  public initialSortordini: Object = {};

  showagscadenti:boolean=false;
  agscadenti:any=[];


  ordini_attesa_risp=0;
  segnalazioni_non_risolte=0;
  ticket_aperti=0;

  
  backgroundImageUrls: BannerItem[] = [];

  showIndex: number = 0;
  morekpivisible=false;
  showselectkpi=false;
  
  counter: number = 0;
  state = 'in';

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
    private authService: AuthService,
    public cookie: CookieService) { }

  ngOnInit() {
    let kpil=JSON.parse(localStorage.getItem('kpilistv4'+this.globalService.loggedUser.id) || "null");
    if(!kpil){
      this.authService.getkpi({id_user:this.globalService.loggedUser.id}).subscribe(data => {
        this.globalService.kpilist=data.Result;
        this.globalService.kpilist_hp=this.globalService.kpilist.filter((item:any) => item.isprimary ).map((item:any) => {return item});
        localStorage.setItem('kpilistv4'+this.globalService.loggedUser.id, JSON.stringify(this.globalService.kpilist));
      });
    }
    this.apiService.get('hp/kpilistall',{}).subscribe(data => {
      data.Result.forEach((k:any,ind:any)=>{
        this.kpilist.push({
          label:k.name,
          value:k.name
        });
      });
    });

    this.aggiornaContatoreFirme();
    this.intervalloFirme = setInterval(() => { this.aggiornaContatoreFirme(); }, 600000);

    let params={
        user_id:this.globalService.loggedUser.id
    };
    this.apiService.get('organizationchart/getuserpref',params).subscribe(data => {
      

      if(data.Result.jsonkpi){
        this.kpilistSelected=JSON.parse(data.Result.jsonkpi);
      }
 
    });

    this.toolbar = ['Search'];
   
    
   

  }


  public showKPI(){
    
    if(this.cookie.getCookie('showkpi')==''){
      this.morekpivisible=true;
      let paramscookie={
        expireHours:1,
        name:'showkpi',
        value:1
      };
      this.cookie.setCookie(paramscookie);
    }
    
  this.globalService.donotif();
  }
  

  private getTotals(){
    let params= {};
    let ordiniattesarisp=this.apiService.get('home/ordiniattesarisp',params);
    let segnalazioninonrisolte=this.apiService.get('home/segnalazioninonrisolte',params);
    let ticketaperti=this.apiService.get('home/ticketaperti',params);
    
  
    forkJoin([ ordiniattesarisp,segnalazioninonrisolte,ticketaperti]).subscribe(data => {
      this.ordini_attesa_risp=data[0].Result['ordini_attesa_risp'];
      this.segnalazioni_non_risolte=data[1].Result['segnalazioni_non_risolte'];
      this.ticket_aperti=data[2].Result['ticket_aperti'];
      
    });
   
  }
 


  presaVisione() {
    this.morekpivisible=false;
    
  }

  selectkpi(){
    this.showselectkpi=true;
  }
  
  savekpisettings(){
    let params={
      jsonkpi:JSON.stringify(   this.kpilistSelected ),
      user_id:this.globalService.loggedUser.id
    };
    this.apiService.get('organizationchart/setuserpref',params).subscribe(data => {
      this.showselectkpi=false; 
      this.authService.getkpi({id_user:this.globalService.loggedUser.id}).subscribe(data => {
        this.globalService.kpilist=data.Result;
        this.globalService.kpilist_hp=this.globalService.kpilist.filter((item:any) => item.isprimary ).map((item:any) => {return item});
        localStorage.setItem('kpilistv4'+this.globalService.loggedUser.id, JSON.stringify(this.globalService.kpilist));
      //  this.showKPI();
        window.location.reload();
      });
    });
  }

  
  showOtherKPI(){
    this.morekpivisible=true;
  }
  apriOrdine(o:any){
    console.log(o);
  }
 
  

  gotoArkiWebAGScadenti(){
  
  }
  
  gotoTickets(){
  
  }
  


  private getAGscadenti(){
    this.showagscadenti=true;
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('ag/agscadenti',params).subscribe(data => {
      this.agscadenti=data;
     
    });
  }
  
  private getTicketsInCorso(){
    this.showTickets=true;
    let tic:any[]=[];
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('tickets/ticketsincorso',params).subscribe(data => {
      let idt=0;
      let det:any[]=[];
      data.Result.forEach((ti:any)=>{
        if((ti.idticket!=idt)&&(idt!=0)){
          let ct:any=det[0];
          ct.ag=det;
          tic.push(ct);
          det=[];
        }
        det.push(ti);
        idt=ti.idticket;
      });
      if(det.length>0){
        let ct:any=det[0];
        ct.ag=det;
        tic.push(ct);
      }
      this.ticketsInCorso=tic;
      this.ticketstable.refresh();
    });
  
  }

  apriTicket(){

  }
  
  gotoArkiWebSign(){

  }


  gotoKpi(kpi:any){
   
  /*
    if(kpi.name=='Ticket-In corso'){
      this.getTicketsInCorso();
      return;
    }
    if(kpi.name=='Ordini-Ordini da approvare'){
      this.getOrdiniDaApprovare();
      return;
    }
    if(kpi.name=='ArkiGuest-In scadenza oggi'){
      this.getAGscadenti();
      return;
    }
  */
    if(kpi.link!=''){
      this.router.navigateByUrl(kpi.link.replace('?','QUESTION').replace('=','UGUAL'));
    }
  }
  resizeKpiTreegrid(){ 
    console.log('resizeresizeresizeresizeresize');
    const parentDiv = document.getElementById('parenttreegrid');
    console.log('resizeresizeresizeresizeresize',parentDiv);
    (parentDiv as HTMLElement).style.width ='100%';
    (parentDiv as HTMLElement).style.height =(screen.height-390)+'px';
  }
  refreshkpi(){
 
    this.messageEvent.emit(true);
    this.authService.getkpi({id_user:this.globalService.loggedUser.id}).subscribe(data => {
      this.globalService.kpilist=data.Result;
      this.globalService.kpilist_hp=this.globalService.kpilist.filter((item:any) => item.isprimary ).map((item:any) => {return item});
      if(this.globalService.loggedUser)
        localStorage.setItem("kpilistv4"+this.globalService.loggedUser.id, JSON.stringify(this.globalService.kpilist));
      this.messageEvent.emit(false);
   
    });
  }

  aggiornaContatoreFirme() {
    const utente = (this.globalService as any).loggedUser;
    const idUtente = utente?.id || 0; 

    const url = 'https://lavilladev.homeip.net/FIRME_DOCUMENTI/fn_firme.php';

    // Usiamo URLSearchParams per simulare un form classico (application/x-www-form-urlencoded)
    // A volte PHP fa fatica a leggere il FormData (multipart/form-data) puro senza gli header giusti.
    const bodyArgs = new URLSearchParams();
    bodyArgs.append('id_utente', idUtente.toString());

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: bodyArgs.toString()
    })
    .then(response => response.text()) // Leggiamo come testo prima per debug
    .then(text => {
        try {
            // Proviamo a interpretare il JSON
            const data = JSON.parse(text);
            this.numeroDocumentiDaFirmare = parseInt(data.countDaFirmare) || 0;
            this.numeroDocumentiInAttesa = parseInt(data.countAttesaFirma) || 0;
        } catch (e) {
            // Se PHP ha stampato un errore al posto del JSON, lo vediamo nella console
            console.error("Risposta del server non in formato JSON:", text);
            this.numeroDocumentiDaFirmare = 0;
            this.numeroDocumentiInAttesa = 0;
        }
    })
    .catch(error => console.error("Errore di rete o CORS nel recupero firme:", error));
  }

  apriFirme() {
    window.open('https://lavilladev.homeip.net/FIRME_DOCUMENTI/', '_blank');
  }

  ngOnDestroy() {
    if (this.intervalloFirme) {
        clearInterval(this.intervalloFirme);
    }
  }
 
}

export interface BannerItem {
  imageUrl: string;
  title: string;
  description: string;
  callToAction: string;
  buttonUrl: string;
}
